export const ROUTES = {
	APPLICATIONS: 'applications' as const,
	APPLICATION_DETAILS: 'applicationDetails' as const,
	OPERATION_DETAILS: 'operationDetails' as const,
	ADD_APPLICATION: 'addApplication' as const,
	ADD_OPERATION: 'addOperation' as const,
	EDIT_APPLICATION: 'editApplication' as const,
	EDIT_OPERATION: 'editOperation' as const,
	EXPORT_OPERATION_TO_TASK: 'exportOperationToTask' as const,
};

export type RouteType = (typeof ROUTES)[keyof typeof ROUTES];

export interface RouteInfo {
	route: RouteType;
	applicationId?: string;
	operationId?: string;
}